dsStakeSelectionPopup = {};
dsStakeSelectionPopup.popups = [];

dsStakeSelectionPopup.create = function () {
  var object = new PIXI.Container();
  dsStakeSelectionPopup.container = object;

  // Get all objects on the autoplay dialog
  object.dialog = {};
  object.dialog.callbacks = {};

  object.openDialog = dsStakeSelectionPopup.openDialog;
  object.selectLayout = dsStakeSelectionPopup.selectLayout;
  object.updateLayout = dsStakeSelectionPopup.updateLayout;
  object.forceClose = dsStakeSelectionPopup.forceClose;

  dsStakeSelectionPopup.luckyBetPlatformEnabled = false;
  dsStakeSelectionPopup.luckyBetPlatformVisible = false;

  dsStakeSelectionPopup.goldenBetSelected = false;
  dsStakeSelectionPopup.canPlaceGoldenBet = false;
  dsStakeSelectionPopup.goldenBetStakes = undefined;
  dsStakeSelectionPopup.availableStakes = undefined;

  // Hide by default
  object.visible = false;
  object.isActive = false;

  dsStakeSelectionPopup.popups.push(object);

  const self = this;
  messageBus.subscribe('spinner:GameConfigEvent', dsStakeSelectionPopup.createButtons.bind(dsStakeSelectionPopup));
  messageBus.subscribe('game:modal', dsStakeSelectionPopup.onModal.bind(dsStakeSelectionPopup));

  return object;
};

dsStakeSelectionPopup.destroy = function (popup) {
  var index = dsStakeSelectionPopup.popups.indexOf(popup);
  if (index === -1) {
    console.log('Could not destroy stake selection popup as it could not be found');
    return;
  }

  dsStakeSelectionPopup.popups.splice(index, 1);
};

dsStakeSelectionPopup.initialise = function (json, object) {
  object.dialog.buttonGlow = resourceManager.get('buttonContainer:buttonBar:stakeButton:glow');
  object.dialog.buttonGlow.visible = false;

  // Clickable background behind panel
  object.dialog.touchCancel = resourceManager.createObject('colourBox', 'touchCancel', json.FQN, {
    width: 1000,
    height: 1000,
    x: -1000,
    y: -1000,
    scale: 4,
    alpha: 0.7,
    colour: 0x000000,
  });
  object.dialog.touchCancel.visible = false;
  object.dialog.touchCancel.interactive = false;
  object.dialog.touchCancel.mousedown = object.dialog.touchCancel.touchstart = dsStakeSelectionPopup.onCancel;

  object.dialog.buttons = [];
  //    object.dialog.buttonsDescription = [];

  // Create background / title - set interactive to prevent clickthrough
  object.dialog.background = resourceManager.createObject('sprite', 'background', json.FQN, {
    fileName: json.backgroundFile,
  });
  object.dialog.background.interactive = true;

  var maxWidth = checkForDefined(json.maxWidth) ? json.maxWidth : object.dialog.background.width;
  resourceManager.createObject('text', 'title', json.FQN, {
    text: '',
    translationPhrase: json.translationPhrase,
    fontDefinition: 'popupTitle',
    x: maxWidth / 2,
    y: 40,
    maxWidth: 600,
  });

  object.dialog.seperator = resourceManager.createObject('sprite', 'seperator', json.FQN + ':background', {
    fileName: 'Desktop_UI_SystemSettings/Pop_Up_Panel_Line.png',
    x: 100,
    y: 60,
  });

  object.dialog.JSONbuttonFQN = json.FQN;
  object.dialog.JSONbuttonText = json.buttonText;
  object.dialog.JSONbuttonFile = json.buttonFile;
  object.dialog.JSONbuttonFont = json.buttonDescriptionDefinition;
  object.dialog.JSONMaxWidth = maxWidth;

  object.dialog.luckyBetContainer = resourceManager.createObject(
    'container',
    'luckyBetContainer',
    json.FQN + ':background',
    {
      fileName: 'Golden_Bet<&social&>/Button_Bet_ON.png',
      x: 350,
      y: 133,
      scale: 0.65,
      anchor: 0.5,
    }
  );

  object.dialog.luckyBetOn = resourceManager.createObject(
    'sprite',
    'luckyBetOn',
    json.FQN + ':background:luckyBetContainer',
    {
      fileName: 'Golden_Bet<&social&>/Button_Bet_ON.png',
      anchor: 0.5,
    }
  );
  object.dialog.luckyBetOn.interactive = false;
  object.dialog.luckyBetOn.mousedown = object.dialog.luckyBetOn.touchstart = dsStakeSelectionPopup.luckyBetOnPressed;
  object.dialog.luckyBetOn.visible = false;

  object.dialog.luckyBetOff = resourceManager.createObject(
    'sprite',
    'luckyBetOff',
    json.FQN + ':background:luckyBetContainer',
    {
      fileName: 'Golden_Bet<&social&>/Button_Bet_OFF.png',
      anchor: 0.5,
    }
  );
  object.dialog.luckyBetOff.interactive = true;
  object.dialog.luckyBetOff.mousedown = object.dialog.luckyBetOff.touchstart = dsStakeSelectionPopup.luckyBetOffPressed;
  object.dialog.luckyBetOff.visible = true;

  object.dialog.continueButton = resourceManager.createObject('sprite', 'continueButton', json.FQN + ':background', {
    fileName: 'Desktop_UI_AutoplaySettings/Desktop_Start_Button.png',
    x: 360,
    y: 440,
    anchor: 0.5,
    alpha: 1,
  });
  object.dialog.continueButton.text = resourceManager.createObject(
    'text',
    'continueButtonText',
    json.FQN + ':background' + ':continueButton',
    {
      translationPhrase: 't_continue',
      fontDefinition: 'popupBetSettingsContinue',
      maxWidth: 220,
      x: -3,
      y: -3,
    }
  );

  object.dialog.continueButton.interactive = true;
  object.dialog.continueButton.mousedown = object.dialog.continueButton.touchstart =
    dsStakeSelectionPopup.onContinuePressed;

  var closeButton = resourceManager.createObject('sprite', 'closeButton', json.FQN + ':background', {
    fileName: 'Desktop_UI_SystemSettings/Desktop_Close_Button.png',
    x: 683,
    y: 28,
    anchor: 0.5,
  });

  closeButton.interactive = true;
  closeButton.mousedown = closeButton.touchstart = dsStakeSelectionPopup.onCancel;
};

dsStakeSelectionPopup.onModal = function (msg) {
  // Pressing max bet or lucky bet takes us out of modal but we are still visible, keep modal
  // This means the dialog will be still open allowing the player to spin behind the stake dialog - go back to modal if
  // the dialog is still open
  if (dsStakeSelectionPopup.isActive) {
    if (msg.reason === undefined) {
      messageBus.post('game:modal', { reason: 'Stake dialog open' });
    }
  }
};

dsStakeSelectionPopup.createButtons = function (configEvent) {
  let stakeController = resourceManager.getController('stakeController');
  const maxNumStakeButtons = stakeController.Stakes.length;

  dsStakeSelectionPopup.goldenBetStakes = configEvent.data.slotConfig.gameModes.GOLDENBET_BUY.coinSizes;

  dsStakeSelectionPopup.luckyBetPlatformEnabled = configEvent.data.uiElements.btnUpstake.enabled;
  dsStakeSelectionPopup.luckyBetPlatformVisible = configEvent.data.uiElements.btnUpstake.visible;

  // Create all buttons we will need
  for (var i = 0; i < maxNumStakeButtons; i++) {
    var button = resourceManager.createObject(
      'sprite',
      'button' + i,
      dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ':background',
      { fileName: dsStakeSelectionPopup.container.dialog.JSONbuttonFile }
    );
    //maxWidth = (checkForDefined(json.maxButtonWidth) ? json.maxButtonWidth : button.width);

    button.stakeIndex = i;
    button.interactive = true;
    button.mousedown = button.touchstart = dsStakeSelectionPopup.onStakeButtonPressed;
    button.anchor.set(0.5);

    var buttonText = resourceManager.createObject(
      'text',
      'buttonText' + i,
      dsStakeSelectionPopup.container.dialog.JSONbuttonFQN + ':background' + ':button' + i,
      {
        text: dsStakeSelectionPopup.container.dialog.JSONbuttonText,
        maxWidth: 90,
        maintainAspectRatio: false,
        fontDefinition: 'popupBetSettingsMoney',
        x: -4,
        y: -3,
      }
    );

    dsStakeSelectionPopup.container.dialog.buttons.push({
      button: button,
      text: buttonText,
      stake: stakeController.Stakes[i],
    });
  }
};

dsStakeSelectionPopup.onCancel = function () {
  dsStakeSelectionPopup.isActive = false;

  dsStakeSelectionPopup.container.dialog.chosenStake = undefined;
  dsStakeSelectionPopup.container.dialog.continueButton.interactive = false;

  soundManager.play('buttonPressV3Exit');
  dsStakeSelectionPopup.forceClose();
  dsStakeSelectionPopup.container.dialog.callbacks.cancelled();
};

dsStakeSelectionPopup.maxBetPressed = function () {
  var popup = dsStakeSelectionPopup.container;
  var thisIndex = popup.dialog.numItems - 1;

  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    popup.dialog.buttons[i].text.style.fill = 0xffffff;
  }

  popup.dialog.continueButton.alpha = 1;
  popup.dialog.continueButton.text.style.fill = 0x62e702;

  popup.dialog.buttons[thisIndex].text.style.fill = 0x62e702;
  popup.dialog.chosenStake = popup.dialog.buttons[thisIndex].button.stakeIndex;
  popup.dialog.continueButton.interactive = true;

  // Now we have left dialog, inform game of stake selected
  game.resetWinnings();
  popup.dialog.callbacks.stakeSelected(popup.dialog.chosenStake);

  dsStakeSelectionPopup.canPlaceGoldenBet = resourceManager
    .get('buttonContainer:buttonBar:luckyBetToggleButton')
    .getCanPlaceBet();

  popup.dialog.luckyBetContainer.visible = dsStakeSelectionPopup.canPlaceGoldenBet;
};

dsStakeSelectionPopup.luckyBetOffPressed = function () {
  let popup = dsStakeSelectionPopup.container;

  soundManager.play('activateGoldenBet');

  popup.dialog.luckyBetOn.interactive = true;
  popup.dialog.luckyBetOff.interactive = false;

  popup.dialog.luckyBetOn.visible = true;
  popup.dialog.luckyBetOff.visible = false;

  dsStakeSelectionPopup.goldenBetSelected = true;

  let encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
  encoreButtonLB.onPressedCallback(true);

  var stakeController = resourceManager.getController('stakeController');
  popup.selectLayout(stakeController.Stakes);

  popup.dialog.buttons[stakeController.SelectedStakeIndex].text.style.fill = 0x62e702;

  dsStakeSelectionPopup.toggleGoldenBetStakes(true);
};

dsStakeSelectionPopup.luckyBetOnPressed = function () {
  let popup = dsStakeSelectionPopup.container;
  soundManager.play('cancelGoldenBet');

  dsStakeSelectionPopup.goldenBetSelected = false;

  popup.dialog.luckyBetOn.interactive = false;
  popup.dialog.luckyBetOff.interactive = true;

  popup.dialog.luckyBetOn.visible = false;
  popup.dialog.luckyBetOff.visible = true;

  let encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
  encoreButtonLB.onPressedCallback(true);

  var stakeController = resourceManager.getController('stakeController');
  popup.selectLayout(stakeController.Stakes);

  popup.dialog.buttons[stakeController.SelectedStakeIndex].text.style.fill = 0x62e702;

  dsStakeSelectionPopup.toggleGoldenBetStakes(false);
};

dsStakeSelectionPopup.onStakeButtonPressed = function () {
  var popup = this.parent.parent;

  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    popup.dialog.buttons[i].text.style.fill = 0xffffff;
  }

  popup.dialog.continueButton.alpha = 1;
  popup.dialog.continueButton.text.style.fill = 0x62e702;

  this.children[0].style.fill = 0x62e702;
  popup.dialog.chosenStake = this.stakeIndex;
  popup.dialog.continueButton.interactive = true;

  soundManager.play('autoplayChing');

  // Now we have left dialog, inform game of stake selected
  game.resetWinnings();
  popup.dialog.callbacks.stakeSelected(this.stakeIndex);

  dsStakeSelectionPopup.canPlaceGoldenBet = resourceManager
    .get('buttonContainer:buttonBar:luckyBetToggleButton')
    .getCanPlaceBet();

  popup.dialog.luckyBetContainer.visible = dsStakeSelectionPopup.canPlaceGoldenBet;
};

dsStakeSelectionPopup.toggleGoldenBetStakes = function (show) {
  if (show) {
    dsStakeSelectionPopup.container.dialog.buttons.forEach((button) => {
      const adjustedStake = button.stake / 10;
      if (!dsStakeSelectionPopup.goldenBetStakes.includes(adjustedStake)) {
        button.button.visible = false;
      }
    });
  } else {
    dsStakeSelectionPopup.container.dialog.buttons.forEach((button) => {
      button.button.visible = true;
    });
  }
};

dsStakeSelectionPopup.onContinuePressed = function () {
  dsStakeSelectionPopup.isActive = false;
  var popup = dsStakeSelectionPopup.container;
  soundManager.play('buttonPressV3Exit');
  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    popup.dialog.buttons[i].interactive = false;
  }

  timerManager.addTimer(100, dsStakeSelectionPopup.fadeOutDialog, dsStakeSelectionPopup.fadeOutDialogComplete, popup);
  popup.dialog.selectedStakeIndex = popup.dialog.chosenStake;
};

dsStakeSelectionPopup.selectLayout = function (stakes) {
  this.dialog.numItems = stakes.length;
  this.dialog.stakes = stakes;

  if (this.dialog.numItems === 0) {
    console.error('Not stakes passed into stake selection popup');
    return;
  }

  this.dialog.currentHeight = Math.floor((this.dialog.numItems - 1) / 3) + 1;
  this.dialog.currentWidth = this.dialog.numItems < 4 ? this.dialog.numItems : 3;
  if (this.dialog.numItems === 4) {
    this.dialog.currentWidth = 2;
  }

  this.updateLayout();
};

dsStakeSelectionPopup.updateAllLayouts = function () {
  for (var i = 0; i < dsStakeSelectionPopup.popups.length; i++) {
    dsStakeSelectionPopup.popups[i].updateLayout();
  }
};

dsStakeSelectionPopup.updateLayout = function () {
  dsStakeSelectionPopup.container.dialog.continueButton.interactive = true;

  if (!dsStakeSelectionPopup.isActive) {
    return;
  }

  var margin = 28 / resourceManager.selectedAssetResolution.scaleFactor;
  var buttonWidth = this.dialog.buttons[0].button.texture.width * resourceManager.selectedAssetResolution.scaleFactor;
  var fullWidth =
    (this.dialog.background.texture.width - margin * 2) * resourceManager.selectedAssetResolution.scaleFactor;

  // Layout buttons we are going to use
  var currentButtonIndex = 0;
  var itemsRemaining = this.dialog.numItems;
  var layoutString = '';
  var stakeController = resourceManager.getController('stakeController');
  var maxStake =
    stakeController.Stakes[stakeController.Stakes.length - 1] /
    (stakeController.CurrentStake / stakeController.BaseStake);
  var stakes = stakeController.Stakes;

  var xLeft = 80;
  var xRight = 630;
  var yStart = 225;
  var columns = 6;

  var xGap = (-xLeft + xRight) / (columns - 1);
  var yGap = 50;

  var rowCount = 0;
  var colCount = 0;

  for (let i = 0; i < stakes.length; i++) {
    if (rowCount === columns) {
      rowCount = 0;
      colCount++;
    }

    var xPos = xLeft + xGap * rowCount;
    var yPos = yStart + yGap * colCount;

    if (stakes[i]) {
      this.dialog.buttons[i].button.position.set(xPos, yPos);
      this.dialog.buttons[i].button.interactive = true;
      this.dialog.buttons[i].button.alpha = 1;
      this.dialog.buttons[i].button.exists = true;
    } else {
      this.dialog.buttons[i].button.position.set(xPos, yPos);
      this.dialog.buttons[i].button.interactive = false;
      this.dialog.buttons[i].button.alpha = 0.5;
      this.dialog.buttons[i].button.exists = false;
    }
    rowCount++;
  }

  for (var i = 0; i < this.dialog.currentHeight; i++) {
    var itemsInThisRow = Math.min(this.dialog.currentWidth, itemsRemaining);
    layoutString += itemsInThisRow.toString() + ',';
    var buttonSpace = 15;
    var buttonOffsetX = buttonSpace + buttonWidth;
    var buttonStartX =
      (this.dialog.background.texture.width / 2) * resourceManager.selectedAssetResolution.scaleFactor -
      (itemsInThisRow - 1) * (buttonOffsetX * 0.5);

    for (var j = 0; j < itemsInThisRow; j++) {
      var x = buttonStartX + j * buttonOffsetX;
      var y = ((420 - this.dialog.currentHeight * 156) / (this.dialog.currentHeight + 1)) * (i + 1) + i * 125 + 184;
      var stake = this.dialog.stakes[currentButtonIndex];

      if (!this.dialog.buttons[currentButtonIndex].button) {
        return;
      }
      this.dialog.buttons[currentButtonIndex].button.visible = true; //(stake <= maxStake);

      this.dialog.buttons[currentButtonIndex].text.setText(MeterManager.formatText(stake));

      this.dialog.buttons[currentButtonIndex].text.anchor.set(0.5);

      if (this.dialog.buttons[currentButtonIndex].button.stakeIndex === stakeController.SelectedStakeIndex) {
        this.dialog.buttons[currentButtonIndex].text.style.fill = 0x62e702;
      } else {
        this.dialog.buttons[currentButtonIndex].text.style.fill = 0xffffff;
      }

      currentButtonIndex++;
    }
    itemsRemaining -= itemsInThisRow;
  }
};

dsStakeSelectionPopup.fadeInDialog = function (progress, object) {
  object.alpha = progress;
};

dsStakeSelectionPopup.fadeInDialogCompete = function (object) {
  // Set all buttons to interactive
  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    object.dialog.buttons[i].interactive = true;
  }

  object.dialog.touchCancel.interactive = true;
  object.dialog.touchCancel.visible = true;

  object.alpha = 1;
};

dsStakeSelectionPopup.fadeOutDialog = function (progress, object) {
  object.alpha = 1 - progress;
};

dsStakeSelectionPopup.fadeOutDialogComplete = function (object) {
  dsStakeSelectionPopup.forceClose();

  // Now we have left dialog, inform game of stake selected
  object.dialog.callbacks.stakeSelected(object.dialog.selectedStakeIndex);

  object.dialog.touchCancel.interactive = false;
  object.dialog.touchCancel.visible = false;
};

dsStakeSelectionPopup.forceClose = function () {
  dsStakeSelectionPopup.container.dialog.buttonGlow.visible = false;
  dsStakeSelectionPopup.container.visible = false;
  dsStakeSelectionPopup.container.alpha = 1;
  dsStakeSelectionPopup.isActive = false;
};

dsStakeSelectionPopup.openDialog = function (stakes, stakeSelectedCallback, cancelledCallback) {
  dsStakeSelectionPopup.isActive = true;

  if (
    checkForUndefined(
      stakeSelectedCallback,
      'stake selected callback was not defined in dsStakeSelectionPopup.openDialog',
      true
    ) ||
    checkForUndefined(cancelledCallback, 'Cancel callback was not defined in dsStakeSelectionPopup.openDialog', true)
  ) {
    return;
  }

  // set correct state of dialog lucky bet button on entry
  let encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
  this.dialog.luckyBetOn.interactive =
    encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled;
  this.dialog.luckyBetOff.interactive =
    !encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled;

  this.dialog.luckyBetOn.visible =
    encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformVisible;
  this.dialog.luckyBetOff.visible =
    !encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformVisible;

  let luckyBetOn = encoreButtonLB._flags.showLuckyBetActive && dsStakeSelectionPopup.luckyBetPlatformEnabled;

  //  encoreEffect.cancelPopup();
  this.dialog.buttonGlow.visible = true;

  // Fade in dialog
  this.visible = true;
  this.alpha = 0;
  timerManager.addTimer(100, dsStakeSelectionPopup.fadeInDialog, dsStakeSelectionPopup.fadeInDialogCompete, this);

  // Store callbacks
  this.dialog.callbacks.stakeSelected = stakeSelectedCallback;
  this.dialog.callbacks.cancelled = cancelledCallback;

  // Set up layout
  dsStakeSelectionPopup.isActive = true;
  this.selectLayout(stakes);

  // highlight current stake
  let stakeController = resourceManager.getController('stakeController');
  for (var i = 0; i < stakeController.Stakes.length; i++) {
    if (this.dialog.buttons[i].button.stakeIndex === stakeController.SelectedStakeIndex) {
      this.dialog.buttons[i].text.style.fill = 0x62e702;

      // set the current stake on entry otherwise it clears down when the dialog is closed with no selection.
      this.dialog.chosenStake = stakeController.SelectedStakeIndex;
    } else {
      this.dialog.buttons[i].text.style.fill = 0xffffff;
    }
  }

  dsStakeSelectionPopup.goldenBetSelected = luckyBetOn;
  dsStakeSelectionPopup.toggleGoldenBetStakes(luckyBetOn);

  dsStakeSelectionPopup.canPlaceGoldenBet = resourceManager
    .get('buttonContainer:buttonBar:luckyBetToggleButton')
    .getCanPlaceBet();

  this.dialog.luckyBetContainer.visible = dsStakeSelectionPopup.canPlaceGoldenBet;
};

dsStakeSelectionPopup.getFileRequired = function (json) {
  return [json.backgroundFile, json.buttonFile, 'Desktop_UI_SystemSettings/Pop_Up_Panel_Line.png'];
};

Reflex.registerEventHandler('resize', dsStakeSelectionPopup.updateAllLayouts);
resourceManager.registerObjectType(
  'dsStakeSelectionEdited',
  dsStakeSelectionPopup.create,
  dsStakeSelectionPopup.initialise,
  dsStakeSelectionPopup.getFileRequired,
  dsStakeSelectionPopup.destroy
);
